import { ExternalLink } from 'lucide-react'

export default function AppFooter() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t border-border bg-muted/30 py-4 px-6">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
        {/* Left: Copyright */}
        <div className="flex items-center gap-1">
          <span>&copy; {currentYear}</span>
          <a
            href="https://signifyid.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            SignifyID LLC
          </a>
        </div>

        {/* Right: Links */}
        <div className="flex items-center gap-6">
          <a
            href="https://signifyid.com/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            Terms
          </a>
          <a
            href="https://signifyid.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            Privacy
          </a>
          <a
            href="https://sigmanote.app/help"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors flex items-center gap-1"
          >
            Help
            <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      </div>
    </footer>
  )
}
